/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from "react";
import API from "../../API";
import { ShowContext } from "../../App";
import Pagination from "react-js-pagination";
import BootstrapTable from "react-bootstrap-table-next";

const Feedback = () => {

    let myHeader = [
        { text: "Sr No", dataField: "srno" },
        { text: "Name", dataField: "name" },
        { text: "Email", dataField: "email" },
        { text: "Number", dataField: "number" },
        { text: "Feedback", dataField: "feedback" },
        { text: "Delete", dataField: "delete" },
    ];

    const { setShow, setMsg } = useContext(ShowContext);
    const [list, setList] = useState();
    const [data, setData] = useState();

    const [curPage, setCurPage] = useState(0);
    const [perPage, setPerPage] = useState(0);
    const [total, setTotal] = useState(0);


    useEffect(() => {
        getFeedbacks(1)
    }, []);

    useEffect(() => {
        if (data) {
            setCurPage(data.current_page);
            setPerPage(data.per_page);
            setTotal(data.total);
            getData()
        }
    }, [data]);


    return <div className="container-fluid p-2">
        <h3>
            <center>Feedback</center>
        </h3>
        {list && <div style={{ marginTop: "20px", marginBottom: "20px" }}>
            <BootstrapTable
                keyField="srno"
                data={list}
                columns={myHeader}
                headerClasses="allTable_header text-center"
            />
        </div>}
        {list && data && <div className="mt-3">
            <Pagination
                totalItemsCount={total}
                activePage={curPage}
                itemsCountPerPage={perPage}
                onChange={(pageNumber) => {
                    getFeedbacks(pageNumber)
                }}
                itemClass="page-item"
                linkClass="page-link"
                firstPageText="First"
                lastPageText="Last"
            />
        </div>}
    </div>

    function getData() {
        let temp = []
        data && data.data?.forEach((item, i) => {
            temp.push({
                ...item,
                srno: 1 + i,
                delete: (
                    <button
                        className="btn btn-danger"
                        onClick={() => {
                            deleteFeedbacks(item.id);
                        }}
                    >
                        Delete
                    </button>
                ),
            })
        })
        setList(temp)
    }

    async function getFeedbacks(page) {
        await API.get("/feedback", { params: { page } })
            .then((res) => {
                if (res.data.status === "success") {
                    setData(res.data.data);
                    setShow(true);
                    setMsg(res.data.message);
                }
            })
            .catch((error) => {
                setShow(true);
                setMsg(error.message);
            });
    }

    async function deleteFeedbacks(id) {
        console.log(id);

        await API.delete("/feedback", { params: { id } })
            .then((res) => {
                if (res.data.status === "success") {
                    setData(pre => ({
                        ...pre,
                        data: pre.data.filter(item => item.id != id)
                    }));
                    setShow(true);
                    setMsg(res.data.message);
                }
            })
            .catch((error) => {
                setShow(true);
                setMsg(error.message);
            });
    }
};

export default Feedback;
